import { Injectable } from "@angular/core";
import { ApiDataService } from "@services/http/ApiDataService";
import { ProcessedDocumentUploadModel } from "../models/ProcessedDocumentUploadModel";
import { Observable } from "rxjs";
import { ProcessedDocumentDetailModel } from "../models/ProcessedDocumentDetailModel";
import { ProcessedDocumentOverviewComponent } from "../pages/processed-document-overview/processed-document-overview.component";
import { ProcessedDocumentFeedbackModel } from "../models/ProcessedDocumentFeedbackModel";
import { ProcessedDocumentRiskModel } from "../models/ProcessedDocumentRiskModel";
import { ProcessedDocumentOverviewModel } from "../models/ProcessedDocumentOverviewModel";

@Injectable()
export class ProcessedDocumentsService extends ApiDataService {
    constructor() {
        super("processeddocuments");
    }

    public getOverview(): Observable<ProcessedDocumentOverviewComponent[]> {
        return this.get<ProcessedDocumentOverviewComponent[]>();
    }

     public getNewOverview(): Observable<ProcessedDocumentOverviewModel[]> {
        return this.get<ProcessedDocumentOverviewModel[]>();
    }

    public getDetail(id?: number): Observable<ProcessedDocumentDetailModel> {
        const url = `/${id}`;
        return this.get<any>(url);
    }

    public canAccess() : Observable<boolean> {
        const url = `/canaccess`;
        return this.get<boolean>(url);
    }

    public postDocument(uploadModel: ProcessedDocumentUploadModel): Observable<number> {
        const url = "/document";

        return this.postWithDocuments<number>(uploadModel, uploadModel.Documents, url);
    }

    public updateDocument(
        id: number,
        uploadModel: ProcessedDocumentRiskModel[],
    ): Observable<ProcessedDocumentRiskModel[]> {
        const url = `/${id}`;
        return this.post<ProcessedDocumentRiskModel[]>(uploadModel, url);
    }

    public advanceWorkflow(id: number): Observable<void> {
        const url = `/${id}/workflow/advance`;
        return this.post(null, url);
    }

    public deleteProcessedDocument(id: number): Observable<void> {
        const url = `/${id}`;
        return this.delete(url);
    }

    public declineSuggestedRisk(feedback: ProcessedDocumentFeedbackModel): Observable<void> {
        const url = `/decline/risk`;
        return this.post<any>(feedback, url);
    }

    public declineSuggestedControl(feedback: ProcessedDocumentFeedbackModel): Observable<void> {
        const url = `/decline/control`;
        return this.post<any>(feedback, url);
    }
}
